import {
  API_ACKNOWLEDGE_IDEAL_ALERT,
  API_GET_ASPEN_ALERT,
  API_GET_ASPEN_ANONYMOUS_USER_ALERT,
  API_GET_IDEAL_CUSTOMER_ALERT,
  API_GET_SERVER_ALERT,
} from "../ApiConstants";
import axios from "../client/rest";

class AlertApi {
  static sharedInstance = new AlertApi();

  constructor() {
    if (AlertApi.sharedInstance !== null) {
      return AlertApi.sharedInstance;
    }
  }

  async getServerAlerts() {
    try {
      const res = await axios.get(API_GET_SERVER_ALERT);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getIdealAlerts() {
    try {
      const res = await axios.get(API_GET_IDEAL_CUSTOMER_ALERT);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async acknowledgeIdealAlert(body: any) {
    try {
      const res = await axios.post(API_ACKNOWLEDGE_IDEAL_ALERT, body);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getAspenAlerts() {
    try {
      const res = await axios.get(API_GET_ASPEN_ALERT);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getAspenAnonymousUserAlerts() {
    try {
      const res = await axios.get(API_GET_ASPEN_ANONYMOUS_USER_ALERT);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default AlertApi.sharedInstance;
